import { TFunction } from 'react-i18next';

import { TranslationKeys } from 'data/translations/de/de';

import { Attribute } from 'proto/Accommodation/Attributes';

export const attributeListMap: Record<Attribute, TranslationKeys | undefined> =
    {
        [Attribute.ActionAndFun]: 'TRANS-action-and-fun',
        [Attribute.AdultsOnly]: 'TRANS-for-adults-only',
        [Attribute.Ayurveda]: 'TRANS-ayurveda',
        [Attribute.BabyCot]: 'TRANS-baby-crib',
        [Attribute.BabyEquipment]: 'TRANS-baby-equipment',
        [Attribute.BabySitting]: 'TRANS-baby-sitting',
        [Attribute.BeautyFarm]: 'TRANS-beauty-farm',
        [Attribute.BuggyRent]: 'TRANS-buggy-rental',
        [Attribute.CentralLocation]: 'TRANS-central-location',
        [Attribute.CharmFlair]: 'TRANS-charme-flair',
        [Attribute.ChildFriendly]: 'TRANS-child-friendly',
        [Attribute.ChildrensBuffet]: 'TRANS-childrens-buffet',
        [Attribute.ChildrensPlayground]: 'TRANS-childrens-playground',
        [Attribute.ChildrensPlayroom]: 'TRANS-childrens-playroom',
        [Attribute.ChildrensPool]: 'TRANS-childrens-pool',
        [Attribute.CityBreaks]: 'TRANS-city-breaks',
        [Attribute.Club]: 'TRANS-club-hotel',
        [Attribute.Cosmetic]: 'TRANS-cosmetic',
        [Attribute.CulinaryDelights]: 'TRANS-culinary',
        [Attribute.Cycling]: 'TRANS-cycling',
        [Attribute.Deluxe]: 'TRANS-premium-luxury',
        [Attribute.DirectBeachAccess]: 'TRANS-direct-beach-location',
        [Attribute.DisneyLand]: 'TRANS-disneyland',
        [Attribute.Diving]: 'TRANS-diving',
        [Attribute.EuropaPark]: 'TRANS-europa-park',
        [Attribute.FamilyHoliday]: 'TRANS-family-friendly',
        [Attribute.Fitness]: 'TRANS-fitness',
        [Attribute.FreeParking]: 'TRANS-free-parking-space',
        [Attribute.FreeWLAN]: 'TRANS-free-wlan',
        [Attribute.GayHotel]: 'TRANS-adult-hotel',
        [Attribute.GentlySlopingSandyBeach]: 'TRANS-flat-beach',
        [Attribute.GermanSpeakingEntertainmentForKids]:
            'TRANS-german-childcare',
        [Attribute.Golf]: 'TRANS-golf',
        [Attribute.GolfOld]: 'TRANS-golf',
        [Attribute.GolfOld2]: 'TRANS-golf',
        [Attribute.GreatSportsOffer]: 'TRANS-sport-offer',
        [Attribute.HandicappedAccessible]:
            'TRANS-partly-handicapped-accessible',
        [Attribute.HansaPark]: 'TRANS-hansa-park',
        [Attribute.HeatedPool]: 'TRANS-heated-pool',
        [Attribute.HeidePark]: 'TRANS-heide-park',
        [Attribute.Hiking]: 'TRANS-hiking',
        [Attribute.HolidayForTwo]: 'TRANS-holiday-for-two',
        [Attribute.HoneymoonTravel]: 'TRANS-honeymoon-travel',
        [Attribute.HorseRiding]: 'TRANS-horse-riding',
        [Attribute.HotelNearTheBeach]: 'TRANS-near-the-beach',
        [Attribute.IndoorPool]: 'TRANS-indoor-pool',
        [Attribute.Internet]: 'TRANS-internet',
        [Attribute.KidsDisco]: 'TRANS-childrens-disco',
        [Attribute.Kitesurfing]: 'TRANS-kite-surfing',
        [Attribute.LaundryService]: 'TRANS-laundry-service',
        [Attribute.LegoLandDenmark]: 'TRANS-legoland-dk',
        [Attribute.LegoLandGermany]: 'TRANS-legoland-de',
        [Attribute.LonghaultJourney]: 'TRANS-long-haul-journey',
        [Attribute.Massages]: 'TRANS-massages',
        [Attribute.MaxiClub]: 'TRANS-maxi-club',
        [Attribute.MedicalService]: 'TRANS-medical-service',
        [Attribute.MiniClub]: 'TRANS-mini-club',
        [Attribute.MoviePark]: 'TRANS-movie-park',
        [Attribute.NiceSmallFamilyRun]: 'TRANS-small-familiar',
        [Attribute.NonSmokingHotel]: 'TRANS-non-smoking-hotel',
        [Attribute.NonSmokingRooms]: 'TRANS-non-smoking-rooms',
        [Attribute.ParkingSpacesAvailable]: 'TRANS-parking-space',
        [Attribute.PetsAllowed]: 'TRANS-pets-allowed',
        [Attribute.PettingZoo]: 'TRANS-petting-zoo',
        [Attribute.PhantasiaLand]: 'TRANS-phantasialand',
        [Attribute.Pool]: 'TRANS-pool',
        [Attribute.QuietLocation]: 'TRANS-quiet-location',
        [Attribute.RelaxationOffersForBodyAndSoul]: 'TRANS-relaxation-offer',
        [Attribute.Restaurant]: 'TRANS-restaurant',
        [Attribute.Sailing]: 'TRANS-sailing',
        [Attribute.SandyBeach]: 'TRANS-sandy-beach',
        [Attribute.Sauna]: 'TRANS-sauna',
        [Attribute.SingleWithChild]: 'TRANS-single-with-child',
        [Attribute.Singles]: 'TRANS-singles',
        [Attribute.SoccerSchool]: 'TRANS-football',
        [Attribute.SportOffersForChildren]: 'TRANS-sport-offers-for-children',
        [Attribute.Squash]: 'TRANS-squash',
        [Attribute.Surfing]: 'TRANS-surfing',
        [Attribute.SwimSchool]: 'TRANS-swimming',
        [Attribute.Tennis]: 'TRANS-tennis',
        [Attribute.Thalasso]: 'TRANS-thalasso',
        [Attribute.ThemeParks]: 'TRANS-theme-parks',
        [Attribute.Transfer]: 'TRANS-transfer',
        [Attribute.VacationAtMediterraneanSea]:
            'TRANS-vacation-at-mediterranean-sea',
        [Attribute.VacationAtNorthOrBalticSea]:
            'TRANS-vacation-at-north-or-baltic-sea',
        [Attribute.VacationInAustria]: 'TRANS-vacation-in-austria',
        [Attribute.VacationInGermany]: 'TRANS-vacation-in-germany',
        [Attribute.VacationInTheMountains]: 'TRANS-vacation-in-the-mountains',
        [Attribute.WaterSlide]: 'TRANS-water-slide',
        [Attribute.WaterSports]: 'TRANS-water-sports',
        [Attribute.Wellness]: 'TRANS-wellness',
        [Attribute.Windsurfing]: 'TRANS-wind-surfing',
        [Attribute.Wingfoiling]: 'TRANS-wing-foiling',
        [Attribute.WinterSports]: 'TRANS-winter-sports',
    };

export const buildAttributeLabel = (value: Attribute, t: TFunction) => {
    const key = attributeListMap[value];

    return key ? t(key) : '';
};
